import { render, staticRenderFns } from "./PropertiesModule.vue?vue&type=template&id=0087f0c7&scoped=true"
import script from "./PropertiesModule.vue?vue&type=script&lang=js"
export * from "./PropertiesModule.vue?vue&type=script&lang=js"
import style0 from "./PropertiesModule.vue?vue&type=style&index=0&id=0087f0c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0087f0c7",
  null
  
)

export default component.exports